<template>
  <v-container class="material-carousel-section-wrapper" fluid>
    <v-row class="title-wrapper pa-md-0" fluid>
      <v-col class="col-12 col-md-10 pa-md-0" offset-md="1">
        <h2 v-html="data.title"></h2>
        <p v-html="data.text"></p>
      </v-col>
    </v-row>
    <v-row class="carousel-wrapper">
      <v-col class="col-12 col-md-10 pa-md-0" offset-md="1">
        <VueSlickCarousel v-bind="settings">
          <template v-for="(post, i) in data.posts">
            <div :key="i" class="item">
              <v-img contain :src="post.image" :alt="post.title" />
              <div class="overlay">
                <div class="content-wrapper">
                  <h3 v-html="post.title"></h3>
                  <a :href="post.url" target="_blank'" class="button"
                    >Download</a
                  >
                </div>
              </div>
            </div>
          </template>
        </VueSlickCarousel>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';

export default {
  name: 'MaterialSectionBusinesses',
  components: {
    VueSlickCarousel,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      settings: {
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        swipeToSlide: true,
        arrows: false,
        dots: true,
        autoplay: false,
        responsive: [
          {
            breakpoint: 475,
            settings: {
              slidesToShow: 1,
              swipe: true,
            },
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
              swipe: true,
            },
          },
        ],
      },
    };
  },
};
</script>

<style lang="sass" scoped>
@import '@/styles/util'
@import '@/styles/style'

.material-carousel-section-wrapper
  padding-top: 100px
  padding-bottom: 100px
  .title-wrapper
    background-repeat: no-repeat
    background-size: cover
    background-position: center top
    min-height: 220px
    margin-bottom: 45px
    .col
      justify-content: center
      align-items: center
      display: flex
      flex-flow: column
      h2
        display: inline-block
        font-family: 'metropolissemi_bold'
        font-style: normal
        font-weight: 600
        font-size: 32px
        color: #003036
        line-height: 1
        padding-bottom: 5px
        border-bottom: 4px solid #26D07C
        margin-bottom: 70px
      p
        font-family: 'metropolisregular'
        font-style: normal
        font-weight: 400
        font-size: 18px
        line-height: 1.4
        text-align: justify
        color: #003036
        margin-bottom: 50px
    img
      max-width: 100%
  .carousel-wrapper
    .item
      position: relative
      display: block
      transition: 0.3s all ease-in-out
      .v-image
        max-width: 100%
        margin-right: 25px
      .overlay
        background: rgba(35, 31, 32, 0.7)
        position: absolute
        display: flex
        justify-content: center
        align-items: flex-end
        width: calc(100% - 25px)
        height: 100%
        top: 0
        left: 0
        opacity: 0
        transition: 0.3s all ease-in-out
        .content-wrapper
          background: #ffffff
          text-align: center
          padding: 25px
          margin-right: 25px
          margin-left: 25px
          margin-bottom: 25px
          h3,
          .button
            font-family: 'metropolisbold'
            font-style: normal
            font-weight: 700
          h3
            font-size: 18px
            line-height: 1.4
            color: #000000
            margin-bottom: 15px
          .button
            background: #3DCF8E
            display: inline-block
            font-size: 16px
            color: #ffffff
            line-height: 1
            text-transform: uppercase
            text-align: center
            outline: none
            text-decoration: none
            padding: 12px 48px
            border-radius: 20px
            transition: all 300ms ease-in-out
            &:hover
              background: #003036
              transition: all 300ms ease-in-out
      &:hover
        transition: 0.3s all ease-in-out
        .overlay
          opacity: 1
          transition: 0.3s all ease-in-out
    ::v-deep
      .slick-dots
        padding: 0 !important
        bottom: -50px
        li
          width: 23px
          height: 23px
          margin: 0 10px
          transition: all 300ms ease-in-out
          &.slick-active
            transition: all 300ms ease-in-out
            button
              width: 23px
              height: 23px
              &:before
                background: #ffffff
                border: 6px solid #26D07C
                width: 23px
                height: 23px
                color: transparent
                border-radius: 50px
                line-height: 1
                top: 0
                left: 0
                transition: all 300ms ease-in-out
          button
            width: 23px
            height: 23px
            padding: 0
            &:before
              background: #003036
              width: 16px
              height: 16px
              color: transparent
              border-radius: 50px
              line-height: 1
              opacity: 1
              top: 3px
              left: 3px
              transition: all 300ms ease-in-out
  @media screen and (max-width: 959px)
    .title-wrapper
      .col
        h2
          font-size: 20px
    .carousel-wrapper
      .item
        .v-image
          margin-right: 0
        .overlay
          width: 100%
</style>
